import { Router, type CanActivateFn } from '@angular/router';
import { TokenService } from '../services/token.service';
import { inject } from '@angular/core';
import { AuthStatus } from '../models';

export const isNotAuthenticatedGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);  // Inyecta el servicio de autenticación
  const router = inject(Router);  // Inyecta el servicio de Router para navegar si es necesario

  // Si el usuario está autenticado, redirige al home
  if(tokenService.authStatus() === AuthStatus.authenticated){
    router.navigateByUrl('/home');
    return false;  // Bloquea el acceso a la ruta actual
  }

  return true;  // Permite el acceso a la ruta si no está autenticado
};
